module.exports = __webpack_public_path__ + "static/img/B32.fabf18e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/service/B32.png
// module id = AVSo
// module chunks = 1